import { Geist, Geist_Mono } from "next/font/google";
import Footer from "../components/Footer";
import Header from "../components/Header";
import "./globals.css";
import "../i18n"; // make sure i18n is loaded globally
import { dir } from "i18next"; // helper to get rtl/ltr
import i18n from "../i18n";
// import backgroundShape2 from "../assets/images/backgroundShape2.svg";
// import Image from "next/image";
import localFont from "next/font/local";

const peyda = localFont({
  src: [
    {
      path: "../assets/fonts/PeydaWeb-Regular.woff2",
      weight: "400",
      style: "normal",
    },
    {
      path: "../assets/fonts/PeydaWeb-Bold.woff2",
      weight: "700",
      style: "normal",
    },
  ],
  variable: "--font-peyda",
  display: "swap",
});

export const metadata = {
  title: "Soroush Sabz",
  description: "Natural and Organic products",
};

export default function RootLayout({ children }) {
  const lang = i18n.language || "fa"; // default language
  const direction = dir(lang); // "rtl" or "ltr"

  return (
    <html lang={lang} dir={direction} className={peyda.variable}>
      <body className={`antialiased`}>
        <Header />
        <main className="main-content">
          {/* <Image
            src={backgroundShape1.src}
            alt="cows"
            width={20}
            height={20}
            className="absolute top-1 -z-5 w-[100%]"
          />
          <Image
            src={backgroundShape2.src}
            alt="cows"
            width={20}
            height={20}
            className="absolute top-[90vw] -z-5 w-[100%]"
          />
          <Image
            src={backgroundShape1.src}
            alt="cows"
            width={20}
            height={20}
            className="absolute top-[150vw] -z-5 w-[100%]"
          />
          <Image
            src={backgroundShape2.src}
            alt="cows"
            width={20}
            height={20}
            className="absolute top-[250vw] -z-5 w-[100%]"
          />
          <Image
            src={backgroundShape1.src}
            alt="cows"
            width={20}
            height={20}
            className="absolute top-[320vw] -z-5 w-[100%]"
          /> */}
          {children}
        </main>
        <Footer />
      </body>
    </html>
  );
}
